export default __webpack_public_path__ + "static/media/SrebrenicaPDF.5fd88351.png";